type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
  strokeColor?: string;
};
const BookIcon = (props: Props) => {
  const {
    width = '24',
    height = '24',
    viewBox = '0 0 24 24',
    strokeColor = '#000000',
  } = props;
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none">
      {/* strokeWidth matches the weight of the clapperboard this sits beside in
          the reel editor: VideoIcon draws a 1-unit stroke in a 14-unit viewBox,
          so the same rendered thickness here is 24/14 ≈ 1.7. Being a ratio, it
          holds at any rendered size. Round caps/joins as VideoIcon has them —
          and at this weight the book's acute outer corners would otherwise
          throw long miter spikes. */}
      <path
        d="M11.9998 6.25V19.1875M0.979004 1.9375C5.11325 2.41667 10.0832 4.33333 11.9998 6.72917C13.9165 4.33333 18.7082 2.41667 23.0207 1.9375V17.2708C18.7082 17.75 13.9165 19.6667 11.9998 22.0625C10.0832 19.6667 5.11325 17.75 0.979004 17.2708V1.9375Z"
        stroke={strokeColor}
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BookIcon;
